<template>
  <div class="calendar-create-content-menu">
    <!-- <div class="calendar-create-content-menu__label">Create</div> -->
    <button v-for="option in options" :key="option.type" type="button" class="calendar-create-content-menu__option" @click="emit('selectPostType', option.type)">
      <IconEmbedded :name="option.icon" :size="22" />
      <span>{{ option.label }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import { SocialPostType } from "@contracts/contentCalendar";
import type { IconName } from "@contracts/IconName";

const emit = defineEmits<{
  (e: "selectPostType", postType: SocialPostType): void;
}>();

const options: Array<{ type: SocialPostType; label: string; icon: IconName }> = [
  { type: SocialPostType.Post, label: "Posts", icon: "social-post" },
  { type: SocialPostType.Reel, label: "Reel", icon: "social-reel" },
  { type: SocialPostType.Story, label: "Story", icon: "social-story" },
];
</script>

<style scoped lang="scss">
.calendar-create-content-menu {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;

  &__label {
    color: #5b5b5b;
    font: 400 14px/18px sans-serif;
    margin-bottom: 2px;
  }

  &__option {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 2px 5px;
    margin: 0 -4px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: #118689;
    font: 400 14px/18px sans-serif;
    cursor: pointer;
    position: relative;
    z-index: 0;
    transition: color 0.12s ease-in-out;

    &::before {
      content: "";
      position: absolute;
      inset: -6px -12px;
      border-radius: 6px;
      background: rgba(17, 134, 137, 0.12);
      opacity: 0;
      z-index: -1;
      transition: opacity 0.12s ease-in-out;
    }

    &:hover::before {
      opacity: 1;
    }

    &:focus-visible {
      outline: 2px solid rgba(17, 134, 137, 0.5);
      outline-offset: 1px;
    }

    :deep(i svg) {
      fill: #0a6668;
    }
  }
}
</style>
